module.exports = [
  {
    "question": {
      "label": "What is your gender, from birth?",
      "prompt": "Q__c244b16e-0431-49a8-86e0-ab75ebf78220"
    },
    "input": "radio",
    "options": [
      {
        "label": "Male",
        "value": "A__7b09f9a0-3f88-4fc7-b156-fb7143d74fd6"
      },
      {
        "label": "Female",
        "value": "A__9808bead-232c-4984-ae33-ca0bdc2d009d"
      }
    ]
  },
  {
    "question": {
      "label": "How old are you?",
      "prompt": "Q__99cd93db-56ed-4058-86f1-a5684c759283"
    },
    "input": "radio",
    "options": [
      {
        "label": "35 or younger",
        "value": "A__ad6564e4-5125-4d01-827a-8a7615b89b55"
      },
      {
        "label": "36-50",
        "value": "A__bd033979-c2c0-4610-9899-e9126060f2a9"
      },
      {
        "label": "51-65",
        "value": "A__9f393bcc-5bc8-495d-b620-5841f0bc0d93"
      },
      {
        "label": "66-80",
        "value": "A__6e0ec96b-ddb5-4dcc-a5cd-df30fed1a7ef"
      },
      {
        "label": "81 or older",
        "value": "A__7181fc0e-b9d9-423d-89c6-42aa8f37a309"
      }
    ]
  },
  {
    "question": {
      "label": "What level of pain are you feeling in your cervical / lumbar spine?",
      "prompt": "Q__d27b4833-0202-42de-a41f-cda3a7a116ed"
    },
    "input": "slider",
    // "options": [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ]
  },
  {
    "question": {
      "label": "Is this spine pain a result of",
      "prompt": "Q__597b65a4-500a-46dc-9f91-0980371451c0"
    },
    "input": "radio",
    "options": [
      {
        "label": "Trauma/Injury",
        "value": "A__c99b987e-285a-446d-8767-f37459eb166a"
      },
      {
        "label": "Overuse",
        "value": "A__c3265637-64bc-4028-9b94-8bf0f0134cf0"
      },
      {
        "label": "Arthritis",
        "value": "A__913be5ec-520e-4bcd-86a3-b4f12174a075"
      },
      {
        "label": "Congenital (From Birth)",
        "value": "A__d72d5666-5d12-4f08-ae21-3cf83bc63baa"
      }
    ]
  },
  {
    "question": {
      "label": "Mark any treatments you've had",
      "prompt": "Q__dd7eaf21-ce8b-4a1c-8123-7fc0d8004a96"
    },
    "input": "checkbox",
    "options": [
      {
        "label": "Injection",
        "value": "A__2cccf747-5a53-42d4-b681-c127f64b8a02"
      },
      {
        "label": "Bracing",
        "value": "A__81b317c4-6cf5-4a0d-8b90-558df41d489e"
      },
      {
        "label": "Physical Therapy",
        "value": "A__7caccb06-e685-4ca6-a84d-6836611e4482"
      },
      {
        "label": "Imaging (x-ray, MRI)",
        "value": "A__6c8019f2-ce18-4512-981c-d8e78b645587"
      },
      {
        "label": "Surgery",
        "value": "A__0d267d03-b822-4501-a024-1f1a42f706bd"
      },
      {
        "label": "None of the Above",
        "value": "A__50b38560-9d33-42cb-9fcd-f9d5b8afe010"
      }
    ]
  },
  {
    "question": {
      "label": "Over time has this condition gotten",
      "prompt": "Q__1e386f7e-23ae-4856-a533-f320a8ca8ff1"
    },
    "input": "radio",
    "options": [
      {
        "label": "Better",
        "value": "A__6bf14f5a-a24f-4e8b-8757-c9be732ad205"
      },
      {
        "label": "Worse",
        "value": "A__61a73454-d517-40d5-97fb-95ec835177b9"
      },
      {
        "label": "Neutral",
        "value": "A__1e6edccb-4418-4189-871d-d18c58969011"
      }
    ]
  },
  {
    "question": {
      "label": "Are your spine problems located in your",
      "prompt": "Q__f5a4de4c-3965-477b-899f-58113cac8f66"
    },
    "input": "radio",
    "options": [
      {
        "label": "Lumbar (Lower Spine)",
        "value": "A__59483b9b-1f8e-47c5-94c3-b285a6d4178a"
      },
      {
        "label": "Cervical (Upper Spine)",
        "value": "A__f4aa60ec-c00d-4081-b1a8-d68745e9caac"
      }
    ]
  },
  {
    "question": {
      "label": "Do you have radiating numbness down your legs?",
      "prompt": "Q__43758602-3311-475e-ad90-06157155edb9"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__98d80130-d616-42ee-b19c-7009d7c87ccb"
      },
      {
        "label": "No",
        "value": "A__86e32724-0e97-456e-b9e6-3e6db8477a3d"
      }
    ]
  },
  {
    "question": {
      "label": "Is the pain worse when standing, or sitting?",
      "prompt": "Q__edc2724c-ad38-4f1a-84d8-780a971c4c6e"
    },
    "input": "radio",
    "options": [
      {
        "label": "Standing",
        "value": "A__d417d8d2-5600-4c8e-95c2-76e0e5d83834"
      },
      {
        "label": "Sitting",
        "value": "A__aa9057df-b817-47d2-9e33-cac88f6d1b13"
      }
    ]
  },
  {
    "question": {
      "label": "Is your pain acute and sharp, or dull and chronic pain?",
      "prompt": "Q__c94c9928-fdeb-43ce-b9e2-a47c35c31398"
    },
    "input": "radio",
    "options": [
      {
        "label": "Dull, Chronic Pain",
        "value": "A__283f6c13-d389-47b2-8de6-4357b26e039b"
      },
      {
        "label": "Sharp, Acute Pain",
        "value": "A__2de7bbec-9e5c-46d5-a67c-fecf07cf61a0"
      }
    ]
  },
  {
    "question": {
      "label": "Lay flat on your back and perform a single leg raise. Do you feel pain down your leg and past your knee?",
      "prompt": "Q__db9cf140-852b-4dfd-97fb-d48d507791f3"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__0f09de94-cb81-43cb-b3ec-445c9bcd6028"
      },
      {
        "label": "No",
        "value": "A__936173dd-20eb-42bd-8619-e86e48651a1a"
      }
    ]
  },
  {
    "question": {
      "label": "Sit upright with your hands behind your back. Bend forward at the hip, with your neck bent down to the chest, and either knee extended. Do you feel any pain in this position?",
      "prompt": "Q__e2be48f3-8242-41c0-b073-04d9a664b695"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__826badce-7393-4369-85bd-1c532491cf3a"
      },
      {
        "label": "No",
        "value": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50"
      }
    ]
  },
  {
    "question": {
      "label": "Does your pain increase when you turn your head?",
      "prompt": "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__67a0871f-5923-4948-b70a-ccf5894760fb"
      },
      {
        "label": "No",
        "value": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c"
      }
    ]
  },
  {
    "question": {
      "label": "Do you have any numbness in your arms?",
      "prompt": "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__215544a6-3f04-4cac-bc83-ab9a982c37bc"
      },
      {
        "label": "No",
        "value": "A__2487d329-c5d5-4d9f-8185-6a316001d098"
      }
    ]
  },
  {
    "question": {
      "label": "Do you have radiating pain in your shoulder that feels sharp, stabbing, or hot?",
      "prompt": "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b"
    },
    "input": "radio",
    "options": [
      {
        "label": "Yes",
        "value": "A__1c165ace-0c64-43b5-8396-dbe9983b890e"
      },
      {
        "label": "No",
        "value": "A__7664ed7b-609a-4519-b4ed-0622d2bccd46"
      }
    ]
  }
]